import { axios } from '../util/axios'
import platform from '../util/platform'

const EMAIL_CHANGER_BASE_URL = 'https://email-changer.olx.com.br'

export const createEmailChangeConfirmationToken = () =>
  axios
    .post(`${EMAIL_CHANGER_BASE_URL}/token/confirmation`, {}, { withCredentials: true })
    .then(response => response.data)

export const validateConfirmationToken = token =>
  axios
    .post(`${EMAIL_CHANGER_BASE_URL}/validate`, { token }, { withCredentials: true })
    .then(response => response.status === 200)

export const sendEmailChangeRequest = (email, token) =>
  axios
    .post(
      `${EMAIL_CHANGER_BASE_URL}/activate/send`,
      {
        email: email.toLowerCase().trim(),
        token,
      },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)

export const activateEmailChangeRequest = (token, confirmationToken) =>
  axios
    .post(
      `${EMAIL_CHANGER_BASE_URL}/activate`,
      { token, confirmationToken },
      { withCredentials: true }
    )
    .then(response => response.data)

export const emailChangeCheckPincodeSms = code => {
  return axios
    .post(
      `${EMAIL_CHANGER_BASE_URL}/validate/pincode/check`,
      {
        code,
        platform,
      },
      { withCredentials: true }
    )
    .then(response => response.data)
}
